var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.806 17.881V4.193H4.194V20.83c.28-.258.603-.532.964-.806a6.896 6.896 0 014.6-1.697 4.436 4.436 0 012.717 1.208 3.584 3.584 0 00.864.598 3.646 3.646 0 003.536-.45 6.825 6.825 0 00.94-.67 10.186 10.186 0 011.68-1.492c2.155-1.55 4.478-2.093 6.707-.882a6.634 6.634 0 011.605 1.243zm.03 3.278a11.585 11.585 0 00-2.68-2.594c-1.338-.726-2.835-.376-4.38.736a9.087 9.087 0 00-.974.81 8.098 8.098 0 00-.4.412 8.098 8.098 0 01-1.397 1.038 5.721 5.721 0 01-5.619.547 5.765 5.765 0 01-1.394-.958 2.248 2.248 0 00-1.394-.636 4.94 4.94 0 00-3.112 1.254 11.236 11.236 0 00-1.069.93c-.19.187-1.236 1.107-1.298 1.18v3.928h23.688M30 2v28H2V2zM10.839 14.71a3.871 3.871 0 113.87-3.871 3.871 3.871 0 01-3.87 3.871z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--image-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ImageIcon';
export default Icon;